// extracted by mini-css-extract-plugin
var _1 = "awFtmalnO4";
var _2 = "bdzrfRj4Ej";
var _3 = "ZiMQFjE365";
var _4 = "vDhUNu6iUO";
var _5 = "ffFjmxZm5Y";
export { _1 as "name", _2 as "nameValue", _3 as "value", _4 as "value_less", _5 as "value_more" }
